"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var list_1 = __importDefault(require("../../list"));

var detail_1 = __importDefault(require("../../detail"));

var add_1 = __importDefault(require("../../add"));

var reducer_1 = __importDefault(require("./reducer"));

var type_1 = require("./type");

var initialState = {
  showAdd: false,
  selectedIds: []
};

function App(props) {
  var FormUI = props.FormUI,
      ViewUI = props.ViewUI,
      dataDef = props.dataDef;

  var _react_1$useReducer = react_1.useReducer(reducer_1.default, initialState),
      _react_1$useReducer2 = _slicedToArray(_react_1$useReducer, 2),
      state = _react_1$useReducer2[0],
      dispatch = _react_1$useReducer2[1];

  var Data = props.Data;
  var width = state.showAdd || state.selectedIds.length ? 6 : 12;
  return react_1.default.createElement(Grid_1.default, {
    container: true,
    spacing: 4
  }, react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: width,
    sm: width,
    md: width,
    lg: width
  }, Data.asyncData !== undefined ? react_1.default.createElement(list_1.default, {
    asyncData: Data.asyncData,
    dataDef: dataDef,
    showNew: function showNew() {
      return dispatch({
        type: type_1.ActionType.SHOW_ADD_FORM
      });
    },
    selectRow: function selectRow(id) {
      return dispatch({
        type: type_1.ActionType.SELECT_ROW,
        payload: id
      });
    }
  }) : react_1.default.createElement(list_1.default, {
    dataDef: dataDef,
    dataLoad: Data.list(),
    showNew: function showNew() {
      return dispatch({
        type: type_1.ActionType.SHOW_ADD_FORM
      });
    },
    selectRow: function selectRow(id) {
      return dispatch({
        type: type_1.ActionType.SELECT_ROW,
        payload: id
      });
    }
  })), state.showAdd || state.selectedIds.length ? react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: width,
    sm: width,
    md: width,
    lg: width
  }, react_1.default.createElement(react_1.default.Fragment, null, state.showAdd && react_1.default.createElement(add_1.default, {
    UI: FormUI,
    insertPromise: Data.insert,
    linkBack: function linkBack() {
      return dispatch({
        type: type_1.ActionType.HIDE_ADD_FORM
      });
    },
    onUpdate: function onUpdate(id) {
      return dataDef.urlPrefix;
    }
  }), state.selectedIds && state.selectedIds.map(function (id) {
    return react_1.default.createElement(detail_1.default, {
      key: "detail-".concat(id),
      config: Object.assign(Object.assign({}, dataDef), {
        width: {
          xs: 12,
          sm: 12,
          md: 12,
          lg: 12
        }
      }),
      ViewUI: ViewUI,
      FormUI: FormUI,
      Data: Data,
      match: {
        params: {
          uuid: id
        }
      },
      onBack: function onBack() {
        return dispatch({
          type: type_1.ActionType.REMOVE_DETAIL,
          payload: id
        });
      },
      onDelete: function onDelete() {
        return dispatch({
          type: type_1.ActionType.DELETE_ITEM,
          payload: id
        });
      }
    });
  }))) : null);
}

exports.default = App;